export const SELECTION = 'selection'
export const PROCEED = 'proceed'
export const DONE = 'done'
